import React from 'react';
import styled from 'styled-components';

interface IProps {
	top?: string;
	left?: string;
	right?: string;
	bottom?: string;
}

const Flower = (props: IProps) => {
	return (
		<Wrapper {...props}>
			<svg
				width='447'
				height='519'
				viewBox='0 0 447 519'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M293.41 270.364C289.327 277.418 282.763 282.704 274.995 285.192C267.228 287.679 258.812 287.19 251.385 283.822C243.957 280.454 238.049 274.447 234.81 266.969C231.57 259.49 231.231 251.074 233.858 243.36C236.485 235.645 241.89 229.182 249.022 225.228C256.155 221.274 264.504 220.112 272.446 221.967C280.389 223.822 287.357 228.563 291.995 235.267C296.633 241.97 298.609 250.157 297.54 258.236C296.977 262.511 295.574 266.632 293.41 270.364Z'
					fill='#E1458D'
				/>
				<path
					d='M133.164 0C136.461 0.226391 139.775 0.311154 143.049 0.712998C159.592 2.40186 175.574 7.64526 189.899 16.0839C204.223 24.5225 216.551 35.9564 226.037 49.6017C241.055 70.2639 248.613 95.4042 247.475 120.914C246.735 150.191 234.867 178.089 214.283 198.94C214.103 199.036 213.903 199.087 213.699 199.087C213.495 199.087 213.295 199.036 213.115 198.94C185.828 171.72 158.57 144.48 131.339 117.219C130.75 116.573 130.408 115.738 130.376 114.864C130.331 76.5743 130.318 38.2882 130.337 0.00552711L133.164 0Z'
					fill='#FED670'
				/>
				<path
					d='M0 133.031C0.226606 136.325 0.31145 139.637 0.713675 142.908C2.40487 159.436 7.65328 175.401 16.0999 189.712C24.5465 204.023 35.9911 216.34 49.6488 225.818C70.3311 240.821 95.4957 248.37 121.03 247.234C150.334 246.495 178.259 234.639 199.129 214.074C199.225 213.895 199.276 213.694 199.276 213.491C199.276 213.287 199.225 213.087 199.129 212.908C171.884 185.643 144.618 158.41 117.33 131.209C116.683 130.62 115.848 130.28 114.974 130.247C76.6471 130.202 38.3246 130.188 0.00553237 130.207L0 133.031Z'
					fill='#FED670'
				/>
				<path
					d='M385.829 519C382.538 518.768 379.218 518.689 375.944 518.287C359.402 516.596 343.422 511.35 329.098 502.912C314.775 494.473 302.447 483.04 292.96 469.397C277.94 448.735 270.381 423.595 271.518 398.085C272.257 368.809 284.125 340.912 304.71 320.064C304.889 319.965 305.089 319.913 305.293 319.913C305.497 319.913 305.698 319.965 305.877 320.064C333.168 347.276 360.427 374.518 387.653 401.786C388.246 402.429 388.588 403.261 388.616 404.134C388.669 442.421 388.683 480.708 388.656 518.994L385.829 519Z'
					fill='#FED670'
				/>
				<path
					d='M519.001 385.968C518.769 382.674 518.689 379.358 518.287 376.092C516.594 359.565 511.345 343.599 502.899 329.289C494.452 314.978 483.009 302.66 469.352 293.181C448.669 278.178 423.505 270.627 397.971 271.76C368.668 272.501 340.747 284.358 319.877 304.921C319.778 305.099 319.726 305.299 319.726 305.503C319.726 305.707 319.778 305.907 319.877 306.086C347.115 333.351 374.381 360.584 401.676 387.785C402.318 388.378 403.153 388.72 404.027 388.746C442.354 388.799 480.676 388.815 518.995 388.792L519.001 385.968Z'
					fill='#FED670'
				/>
				<path
					d='M385.83 0C382.538 0.226391 379.218 0.311154 375.944 0.712998C359.401 2.40154 343.42 7.64382 329.097 16.0825C314.773 24.5212 302.445 35.9563 292.961 49.6017C277.939 70.2622 270.379 95.4032 271.518 120.914C272.258 150.191 284.126 178.089 304.711 198.94C304.89 199.036 305.09 199.087 305.294 199.087C305.497 199.087 305.698 199.036 305.877 198.94C333.168 171.72 360.427 144.48 387.654 117.219C388.248 116.575 388.589 115.739 388.617 114.864C388.669 76.5743 388.683 38.2882 388.657 0.00552711L385.83 0Z'
					fill='#FED670'
				/>
				<path
					d='M519 133.031C518.768 136.325 518.689 139.637 518.286 142.908C516.593 159.435 511.343 175.4 502.897 189.71C494.45 204.021 483.007 216.338 469.351 225.818C448.668 240.819 423.503 248.368 397.97 247.234C368.667 246.495 340.745 234.639 319.876 214.074C319.778 213.896 319.726 213.695 319.726 213.491C319.726 213.287 319.778 213.086 319.876 212.908C347.114 185.643 374.381 158.41 401.675 131.209C402.32 130.62 403.153 130.279 404.026 130.247C442.353 130.202 480.676 130.188 518.995 130.207L519 133.031Z'
					fill='#FED670'
				/>
				<path
					d='M133.164 519C136.461 518.768 139.775 518.689 143.049 518.287C159.592 516.595 175.573 511.35 189.897 502.912C204.221 494.473 216.549 483.04 226.037 469.397C241.054 448.734 248.611 423.594 247.475 398.085C246.735 368.809 234.867 340.912 214.283 320.064C214.104 319.965 213.903 319.913 213.699 319.913C213.495 319.913 213.294 319.965 213.115 320.064C185.828 347.276 158.57 374.518 131.339 401.786C130.751 402.431 130.409 403.262 130.376 404.134C130.331 442.421 130.318 480.708 130.337 518.994L133.164 519Z'
					fill='#FED670'
				/>
				<path
					d='M0 385.968C0.226606 382.674 0.31145 379.358 0.713675 376.093C2.40414 359.565 7.65253 343.598 16.0992 329.288C24.5458 314.977 35.9906 302.659 49.6488 293.182C70.3304 278.177 95.495 270.625 121.03 271.76C150.334 272.502 178.257 284.359 199.129 304.921C199.225 305.101 199.276 305.3 199.276 305.503C199.276 305.706 199.225 305.907 199.129 306.086C171.884 333.351 144.618 360.584 117.33 387.785C116.686 388.378 115.849 388.719 114.974 388.747C76.6471 388.8 38.3246 388.815 0.00553237 388.792L0 385.968Z'
					fill='#FED670'
				/>
			</svg>
		</Wrapper>
	);
};

const Wrapper = styled.div<IProps>`
	position: absolute;
	top: ${props => props.top || 'unset'};
	left: ${props => props.left || 'unset'};
	right: ${props => props.right || 'unset'};
	bottom: ${props => props.bottom || 'unset'};
	opacity: 0.2;
`;

export default Flower;
